import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-portal-root',
  templateUrl: './portal-root.component.html',
  styleUrls: ['./portal-root.component.scss'],
})
export class PortalRootComponent {
  public translations: any;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.translations = {
      account: this.translateService.instant('portalAccount'),
      adultIcon: this.translateService.instant('portalAdultIcon'),
      booksCheckedOut: this.translateService.instant('portalBooksCheckedOut'),
      booksOnHold: this.translateService.instant('portalBooksOnHold'),
      by: this.translateService.instant('portalBy'),
      changeDefaultCatalog: this.translateService.instant('portalChangeDefaultCatalog'),
      checkHoldStatus: this.translateService.instant('portalCheckHoldStatus'),
      checkouts: this.translateService.instant('portalCheckouts'),
      connectAccount: this.translateService.instant('portalConnectAccount'),
      connectOtherAccounts: this.translateService.instant('portalConnectOtherAccounts'),
      connectedAccounts: this.translateService.instant('portalConnectedAccounts'),
      contentPreferences: this.translateService.instant('portalContentPreferences'),
      copyPassphrase: this.translateService.instant('portalCopyPassphrase'),
      create: this.translateService.instant('portalCreate'),
      disconnectAccount: this.translateService.instant('portalDisconnectAccount'),
      displayPassphrase: this.translateService.instant('portalDisplayPassphrase'),
      editAccountInformation: this.translateService.instant('portalEditAccountInformation'),
      editDetails: this.translateService.instant('portalEditDetails'),
      emails: this.translateService.instant('portalEmails'),
      expiration: this.translateService.instant('portalExpiration'),
      expires: this.translateService.instant('portalExpires'),
      for: this.translateService.instant('portalFor'),
      generatePassphrase: this.translateService.instant('portalGeneratePassphrase'),
      getCode: this.translateService.instant('portalGetCode'),
      getPassphrase: this.translateService.instant('portalGetPassphrase'),
      getPhrase: this.translateService.instant('portalGetPhrase'),
      getSharePhrase: this.translateService.instant('portalGetSharePhrase'),
      goBack: this.translateService.instant('portalGoBack'),
      hidePassphrase: this.translateService.instant('portalHidePassphrase'),
      holds: this.translateService.instant('portalHolds'),
      loading: this.translateService.instant('portalLoading'),
      manageBooks: this.translateService.instant('portalManageBooks'),
      manageContent: this.translateService.instant('portalManageContent'),
      managePreferences: this.translateService.instant('portalManagePreferences'),
      minor: this.translateService.instant('portalMinor'),
      minorIcon: this.translateService.instant('portalMinorIcon'),
      mobileNumber: this.translateService.instant('portalMobileNumber'),
      navigationMenu: this.translateService.instant('portalNavigationMenu'),
      passphrase: this.translateService.instant('portalPassphrase'),
      personalizeYourExperience: this.translateService.instant('portalPersonalizeYourExperience'),
      preferredLocation: this.translateService.instant('portalPreferredLocation'),
      preventMoreLinkRequests: this.translateService.instant('portalPreventMoreLinkRequests'),
      returnToCatalog: this.translateService.instant('portalReturnToCatalog'),
      showingFor: this.translateService.instant('portalShowingFor'),
      twoWay: this.translateService.instant('portalTwoWay'),
      unknownAuthor: this.translateService.instant('portalUnknownAuthor'),
      usePhrase: this.translateService.instant('portalUsePhrase'),
      viewDetails: this.translateService.instant('portalViewDetails'),
      welcome: this.translateService.instant('portalWelcome'),
      whoWillThisCodeBeFor: this.translateService.instant('portalWhoWillThisCodeBeFor'),
      yourNextRead: this.translateService.instant('portalYourNextRead')
    };
  }
}
